import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { IconButton, Box, Button, useTheme } from "@mui/material";
import AddAsset from "../asset-management/AddAsset";
import Tooltip from "@mui/material/Tooltip";
import { mkConfig, generateCsv, download } from "export-to-csv";
import SearchBar from "../../components/common-components/Search-bar";
import { Helper } from "../../utils/Helpers";
import {
  FilterList,
  Add,
  CheckBoxRounded,
  CheckBoxOutlineBlankRounded,
} from "@mui/icons-material";
import { ReactComponent as Check } from "../.././assets/icons/checkbox_asset_report.svg";
import { ReactComponent as CheckActive } from "../.././assets/icons/checkbox_asset_report_active.svg";
import { ReactComponent as CheckInter } from "../.././assets//icons/checkbox_asset_report_Inter.svg";
import { useMediaQuery } from "@mui/material";
import {
  errorToster,
  successToster,
  warnToster,
} from "../../shared/toster/Toster";
import ApiClient from "../../apis/Api-client";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { assetColumns } from "./AssetReportColumn";
import { END_POINT } from "../../utils/End-points";
import { ActionGuard } from "../../core/permissions";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { clearRoomNo } from "../../core/store/redux/slices/RoomNo-slice";
import { formatDate } from "date-fns";
const { handlePrintSelectedRows, formatDateForCSV } = new Helper();

const commonIconButtonStyles = {
  backgroundColor: "#FFFFFF",
  borderRadius: "8px",
  width: { sm: "4.317vw", md: "2.778vw" },
  height: { sm: "4.317vw", md: "2.778vw" },
  border: "1px solid rgba(255, 220, 138, 1)",
  border: "1px solid #F7A86E",
  color: "#F7A86E",
};

const AssetTable = ({ column, reportType, endPoint, toggle }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const { api } = ApiClient();
  const { palette } = useTheme();
  const [searchQuery, setSearchQuery] = useState("");
  const [tableData, setTableData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [showColumnFilters, setShowColumnFilters] = useState(false);
  const [selectedRows, setSelectedRows] = useState({});
  const tableContainerRef = useRef(null);
  const [editData, setEditData] = useState(null);
  const [assetStatus, setAssetStatus] = useState([]);
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const dispatch = useDispatch();
  const roomNumberNavigate = useSelector((state) => state.roomNo.number);

  useEffect(() => {
    if (roomNumberNavigate) {
      setSearchQuery(roomNumberNavigate.toString());
      dispatch(clearRoomNo());
    }
  }, []);

  useEffect(() => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollTop = 0;
    }
  }, [data]);

  const isLargeScreen = useMediaQuery("(min-width:900px)");
  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }));
  }, [searchQuery]);

  useEffect(() => {
    const fetchData = async () => {
      await fetchAssetStatus();
    };

    fetchData();
  }, [refresh]);

  useEffect(() => {
    if (pagination.pageIndex >= 0 && pagination.pageSize > 0) {
      fetchAllAssets(pagination.pageIndex, pagination.pageSize);
    }
  }, [refresh]);

  useEffect(() => {
    // setPagination(prev => ({...prev, pageIndex: 0}))
    const delaySearch = setTimeout(() => {
      if (assetStatus.length > 0) {
        fetchAllAssets(pagination.pageIndex, pagination.pageSize);
      }
    }, 1000);

    return () => clearTimeout(delaySearch);
  }, [searchQuery]);

  const prevState = useRef(null);

  useEffect(() => {
    const currentState = JSON.stringify({
      columnFilters,
      globalFilter,
      pagination,
      sorting,
      searchQuery,
    });

    if (prevState.current !== currentState) {
      prevState.current = currentState;
      getTableData(false);
    }
  }, [columnFilters, globalFilter, pagination, sorting, searchQuery]);

  const downloadSelectedAsset = () => {
    const selData = Object.values(data);
    let filData = selData.filter((item) => {
      if (selectedRows[item.serial_no]) return true;
    });

    const formattedData = filData.map((item) => ({
      "Asset Code": item.asset_code ?? "",
      "Asset Name": item.asset_name ?? "",
      Category: item.category ?? "",
      Status: item.status ?? "",
      Brand: item.brand ?? "",
      Model: item.model ?? "",
      Location: item.location ?? "",
      Description: item.description ?? "",
      "Insurance Start Date": item.insurance_start_date
        ? formatDateForCSV(item.insurance_start_date)
        : "",
      "Insurance End Date": item.insurance_end_date
        ? formatDateForCSV(item.insurance_end_date)
        : "",
      "Invoice Date": item.invoice_date
        ? formatDateForCSV(item.invoice_date)
        : "",
      "Invoice Number": item.invoice_number ? `="${item.invoice_number}"` : "",
      "PO Number": item.po_number ? `="${item.po_number}"` : "",
      "Purchase Date": item.purchase_date
        ? formatDateForCSV(item.purchase_date)
        : "",
      "Purchase Price": item.purchase_price ?? "",
      "Vendor Name": item.vendor_name ?? "",
      "Warranty Start Date": item.warrenty_start_date
        ? formatDateForCSV(item.warrenty_start_date)
        : "",
      "Warranty End Date": item.warrenty_end_date
        ? formatDateForCSV(item.warrenty_end_date)
        : "",
      "Warranty Vendor": item.warrenty_vendor ?? "",
    }));

    if (formattedData.length > 0) {
      const csvConfig = mkConfig({
        fieldSeparator: ",",
        decimalSeparator: ".",
        useKeysAsHeaders: true, // Use object keys as column headers
        filename: "assets_report", // CSV filename
      });
      const csvContent = generateCsv(csvConfig)(formattedData);
      download(csvConfig)(csvContent);
    } else {
      errorToster("Please select the row to download");
    }
  };

  const getTableData = async (isPrint, invoice_numbers) => {
    try {
    } catch (error) {
      setTableData([]);
      setRowCount(0);
    } finally {
      setIsLoading(false);
      setIsError(false);
      setIsRefetching(false);
    }
  };

  const handlePaginationChange = (newPagination) => {
    setPagination(newPagination);
    setRefresh((prev) => !prev);
  };

  const handleStatusChange = (rowId, newStatus) => {
    setData((prevData) => {
      const newData = prevData.map((row) =>
        row.serial_no === rowId ? { ...row, status: newStatus } : row
      );

      return newData;
    });
  };

  const updateStatus = async (new_data) => {
    try {
      const FormData = require("form-data");
      const formDataInstance = new FormData();

      formDataInstance.append("data", JSON.stringify({ ...new_data }));

      // Send FormData to API
      const response = await api.postFormData(
        END_POINT.ASSET.ADD_ASSET,
        formDataInstance,
        "ERROR ADDING OR UPDATING ASSET"
      );
      if (response.status === 200) {
        successToster("Asset status changed successfully!");
        setRefresh((prev) => !prev);
      } else {
        errorToster("Failed to change asset status");
      }
    } catch (error) {
      errorToster("Error changing status.");
    }
  };
  const setAssetStatusChange = async (asset_code, status, scrollPos) => {
    if (asset_code) {
      const new_data = {
        asset_code: asset_code,
        asset_status_id: status,
      };

      await updateStatus(new_data);
    }
  };

  const fetchAllAssets = async (page = 0, pageSize = 25) => {
    try {
      setIsLoading(true);

      const response = await api.get(
        `${END_POINT.ASSET.GET_ALL_ASSETS}?page=${
          page + 1
        }&limit=${pageSize}&searchQuery=${encodeURIComponent(searchQuery)}`
      );

      const { assets, total } = response.data.data;

      let modifiedAssetData = assets?.map((item, key) => ({
        ...item,
        serial_no: key + 1 + page * pageSize,
        asset_status: item.asset_status_id,
        asset_category: item.asset_category_id,
        status: item.asset_status_name,
        category: item.asset_category_name.toString(),
        location: item.room_no,
      }));

      setData(modifiedAssetData);

      setRowCount(total);
    } catch (error) {
      console.error("Error fetching assets:", error);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAssetStatus = async () => {
    try {
      let status = await api.get(END_POINT.ASSET.GET_ALL_STATUS);
      const optionStatus = status.data.data.map((item) => ({
        label: item.asset_status_name,
        value: item.asset_status_id,
      }));
      setAssetStatus(optionStatus);
    } catch (error) {
      console.error("Error fetching asset status", error);
      setAssetStatus([]);
    }
  };

  const statusIdToStatus = (id) => {
    const status = assetStatus.find((item) => item.value === id);
    if (status) return status.label;
  };

  const columns = useMemo(
    () =>
      assetColumns(
        handleStatusChange,
        setOpen,
        setEditData,
        setAssetStatusChange,
        setRefresh
      ),
    []
  );
  const table = useMaterialReactTable({
    columns: columns,
    data: data,
    getRowId: (row) => row?.serial_no,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableRowSelection: true,
    enableColumnActions: false,
    enableFullScreenToggle: false,
    enableDensityToggle: false,
    enableHiding: false,
    manualSorting: true,
    manualFiltering: true,
    manualPagination: true,
    enableTopToolbar: false,
    initialState: {
      showColumnFilters: false,
      density: "compact",
      columnPinning:
        window.innerWidth > 768
          ? {
              left: ["mrt-row-expand", "mrt-row-select"],
              right: ["mrt-row-actions"],
            }
          : {}, // Disable pinning on small screens
    },

    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: handlePaginationChange,
    onSortingChange: setSorting,
    onRowSelectionChange: setSelectedRows,
    rowCount,
    state: {
      rowSelection: selectedRows,
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
      showColumnFilters,
    },
    muiTableBodyCellProps: {
      sx: {
        ".MuiCheckbox-root": {
          padding: 0,
        },
        textAlign: "center",
        fontSize: { xs: "2.09vw", sm: "1.2vw", md: "0.833vw" },
        color: "#474747",
        paddingY: { xs: "2vw", sm: "0.7vw" },
        zIndex: 1,
        fontWeight: 400,
        borderColor: "rgb(246, 210, 127)",
        "&.MuiTableCell-root:first-of-type": {
          position: "sticky",
          left: 0,
          // background: "#FFF7D6",
          // zIndex: 2,
          "@media (max-width: 768px)": {
            position: "relative", // Disable sticky on small screens
          },
        },
      },
    },
    muiTableHeadCellProps: {
      sx: {
        ".MuiCheckbox-root": {
          padding: 0,
        },
        ".css-1lderhz": {
          display: "none !important",
        },
        "& .Mui-TableHeadCell-Content": { justifyContent: "center" },
        paddingY: { xs: "2vw", sm: "0.7vw" },
        fontSize: { xs: "2.564vw", sm: "1.439vw", md: "0.972vw" },
        background: palette.tab.gradient,
        color: "#ffffff",
        "& .MuiTableSortLabel-icon": {
          color: "#FFFFFF !important",
        },
        "&.MuiTableCell-root:first-of-type": {
          position: "sticky",
          left: 0,
          // background: "#FFF7D6",
          zIndex: 2,
          "@media (max-width: 768px)": {
            position: "relative", // Disable sticky on small screens
          },
        },
      },
    },
    muiFilterTextFieldProps: {
      onKeyDown: (e) => {
        if (e.key === " " && !e.target.value) {
          e.preventDefault();
        }
      },
      onInput: (e) => {
        e.target.value = e.target.value.trimStart();
      },
      sx: {
        "& .MuiSvgIcon-root": {
          fontSize: "small",
        },
        "& .MuiInput-root": {
          "&:hover:not(.Mui-disabled):before": {
            borderBottom: "1px solid black",
          },
          "&.Mui-focused:after": {
            borderBottom: "1px solid white",
          },
        },
        "& input::placeholder": {
          fontSize: { xs: "1.5vw", sm: "1vw", md: "0.7vw" },
        },
      },
      inputProps: {
        sx: {
          fontSize: {
            xs: "2.199vw",
            sm: "clamp(12px, 1.2vw, 16px)",
            md: "0.694vw",
          },
          minHeight: { sm: "0.5em" },
        },
      },
      size: "small",
    },
    muiSelectAllCheckboxProps: {
      size: "small",
      icon: (
        <CheckBoxOutlineBlankRounded
          fontSize="small"
          sx={{
            color: "#FFE097",
          }}
        />
      ),
      checkedIcon: (
        <CheckBoxRounded
          fontSize="small"
          sx={{
            color: "#FFE097",
          }}
        />
      ),
    },

    muiSelectCheckboxProps: {
      sx: {
        color: "#D9A62E",
        "&.Mui-checked": {
          color: "#D9A62E",
        },
      },
      size: "small",
    },

    muiColumnActionsButtonProps: {
      size: "small",
      sx: {
        color: "#FFFFFF",
      },
    },
    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100],
      size: "small",
      color: "primary",
      shape: "rounded",
      variant: "outlined",
      showFirstButton: rowCount > pagination.pageSize,
      showLastButton: rowCount > pagination.pageSize,
      showNextButton: rowCount > pagination.pageSize,
      showPreviousButton: rowCount > pagination.pageSize,
      sx: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.5rem",

        "& .MuiSelect-root": {
          textAlign: "center", // Center-align the selected value
          fontSize: "0.875rem", // Consistent font size for all devices
          minWidth: "100px", // Consistent width for all devices
          padding: "8px 32px 8px 12px", // Adjust padding for better spacing
        },

        // Styles for the dropdown menu
        "& .MuiMenu-paper": {
          minWidth: "120px", // Ensure the dropdown has enough width
          textAlign: "center", // Center-align dropdown items
        },

        // Styles for the dropdown menu items
        "& .MuiMenuItem-root": {
          justifyContent: "center", // Center-align text in menu items
          fontSize: "0.875rem", // Consistent font size for all devices
          padding: "8px 16px", // Consistent padding for all devices
        },

        // Styles for the pagination actions (buttons)
        "& .MuiTablePagination-actions": {
          flexWrap: "wrap", // Allow buttons to wrap on small screens
          gap: "0.5rem", // Add gap between buttons
        },
      },
    },

    muiTableContainerProps: {
      ref: tableContainerRef,
      sx: {
        overflow: "auto",
        maxWidth: {
          md: toggle ? "82vw" : "93.6vw",
        },
        height: { sm: "80vh", md: "69.5vh" },
        transition: "maxWidth 0.8s ease-in-out",
      },
    },
    muiTableFooterCellProps: {
      align: "right",
      sx: {
        fontSize: { xs: "3vw", sm: "1.8vw", md: "1vw" }, // Adjust font size for all devices
        color: "#D9A62E",
        zIndex: 1,
        fontWeight: 600,
        backgroundColor: "#FFEDD0",
        border: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between", // Ensures proper spacing
        flexWrap: "wrap", // Allows wrapping on smaller screens
        padding: { xs: "10px", sm: "8px", md: "6px" }, // Adjust padding
      },
    },
    muiTableBodyRowProps: {
      hover: false, // Disables hover effect
      sx: {
        "&:hover": {
          backgroundColor: "transparent !important", // Prevent hover color change
        },
      },
    },
    muiTablePaperProps: {
      elevation: 0,
      sx: {
        borderRadius: "0 0 6px 6px",
      },
    },
  });

  const handleToggleFilter = () => {
    setColumnFilters([]);
    setShowColumnFilters((prev) => !prev);
  };

  const buttonConfigs = [
    {
      title: "Download",
      onClick: () => downloadSelectedAsset("download"),
      icon: (
        <FileDownloadOutlinedIcon
          sx={{ fontSize: { sm: "2.59vw", md: "1.667vw" } }}
        />
      ),
    },
    // {
    //   title: "Filter",
    //   onClick: handleToggleFilter,
    //   icon: <FilterList sx={{ fontSize: { sm: "2.59vw", md: "1.667vw" } }} />,
    // },
  ];

  const exportData = async (data, columns, action, reportType) => {
    if (!data || data.length === 0) {
      warnToster(t("pages.reports.no_data_to_export"));
      return;
    }

    // Format data for CSV export
    const formattedData = data.map((row, index) => {
      const rowData = {};
      columns.forEach((column) => {
        const key = column.accessorKey || column.id;
        rowData[column.header] =
          key === "serial_no"
            ? index + 1
            : key === "invoice_type"
            ? t(`pages.reports.gst.${row[key]?.toLowerCase()}`)
            : key === "source_type_name"
            ? t(`booking_source_dropdown.${row[key]?.toLowerCase()}`)
            : row[key] || "";
      });
      return rowData;
    });

    // CSV Configuration
    const csvConfig = mkConfig({
      fieldSeparator: ",",
      decimalSeparator: ".",
      useKeysAsHeaders: true,
    });

    if (action === "print") {
      handlePrintSelectedRows(
        formattedData,
        t(`pages.reports.${reportType.toLowerCase().replace(/\s+/g, "_")}`)
      );
    } else {
      const csvContent = generateCsv(csvConfig)(formattedData);
      download(csvConfig)(csvContent);
    }
    setSelectedRows({});
  };

  const handleExportAllData = async (action) => {
    try {
      const data = await getTableData(true);
      await exportData(data, columns, action, reportType);
    } catch (error) {
      console.error("Error exporting all data:", error);
    }
  };

  const handlePrintOrDownload = async (action) => {
    if (Object.keys(selectedRows)?.length === 0) {
      handleExportAllData(action);
    } else {
      const invoice_numbers = Object.keys(selectedRows);
      const data = await getTableData(true, invoice_numbers);
      await exportData(data, columns, action, reportType);
    }
  };

  return (
    <>
      <Box
        sx={{
          border: "1px solid #FFE097",
          borderRadius: "6px",
          width: { xs: "94.5vw", sm: 1 },
          ml: { xs: "2%", sm: 0 },
          mt : "0.5%"
        }}
      >
        {open ? (
          <AddAsset
            handleClose={() => {
              setOpen(false);
              setEditData(null);
            }}
            editData={(setOpen, editData)}
            setRefresh={setRefresh}
            setOpen={setOpen}
            setEditData={setEditData}
          />
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                backgroundColor: "rgba(255, 246, 232, 1)",
                borderRadius: "6px",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                columnGap: "3%",
                padding: { xs: "3.3% 1.5%", sm: "2% 1.5%", md: "1.2% 1.5%" },
              }}
            >
              <Box
                sx={{
                  width: { xs: "83.59vw", sm: "33%", md: "35%" },
                  pb: { xs: "3.5vw", sm: 0 },
                }}
              >
                <SearchBar
                  startAdornment={true}
                  placeholder="Search by Name, Code, Status, Location"
                  height={{ xs: "10.256vw", sm: "4.317vw", md: "2.778vw" }}
                  boxColor="#FFDC8A"
                  iconColor="#DEA829"
                  setSearchKey={setSearchQuery}
                  searchKey={searchQuery}
                />
              </Box>

              <Box
                sx={{
                  width: { sm: "27%", md: "22%" },
                  display: { xs: "none", sm: "flex" },
                  alignItems: "center",
                }}
              ></Box>

              <Box
                sx={{
                  borderTop: { xs: "1px solid #FFE097", sm: "none" },
                  borderRight: { xs: "1px solid #FFE097", sm: "none" },
                  borderLeft: { xs: "1px solid #FFE097", sm: "none" },
                  width: { xs: "103.5%", sm: "22%", md: "22%" },
                  backgroundColor: { xs: "white", sm: "inherit" },
                  display: "flex",
                  alignItems: "center",
                  mb: { xs: "-13px", sm: 0 },
                  padding: { xs: "3.3% 1.5%", sm: 0 },
                  justifyContent: { xs: "flex-end", sm: "space-between" },
                  ml: { xs: 0, sm: "auto" },
                  gap: { xs: 1.5, sm: 0 },
                }}
              >
                <Box
                  sx={{
                    width: { xs: "30%" },
                    display: { xs: "flex", sm: "none" },
                  }}
                ></Box>
                <Box>
                  <Button
                    variant="outlined"
                    fullWidth
                    sx={{
                      fontSize: { xs: "3.08vw", sm: "1.68vw", md: "0.97vw" },
                      fontWeight: 600,
                      textWrap: "nowrap",
                    }}
                    onClick={() => setOpen(true)}
                    startIcon={
                      <Add
                        fontSize="small"
                      />
                    }
                  >
                    ADD ASSET
                  </Button>
                </Box>
                {buttonConfigs.map(({ title, onClick, icon }) => (
                  <ActionGuard key={title} action="export">
                    <Tooltip title={t(`pages.reports.${title.toLowerCase()}`)}>
                      <IconButton
                        size="small"
                        sx={commonIconButtonStyles}
                        onClick={onClick}
                      >
                        {icon}
                      </IconButton>
                    </Tooltip>
                  </ActionGuard>
                ))}
              </Box>
            </Box>
            <Box>
              <MaterialReactTable table={table} />
            </Box>
          </>
        )}
      </Box>
    </>
  );
};
export default AssetTable;
